const { VUE_APP_API_URL, VUE_APP_API_MYELSA_URL } = process.env;

const appConfig = {
  apiUrl:        VUE_APP_API_URL + 'api/',
  imgUrl:        VUE_APP_API_URL + 'storage/',
  apiUrl_myelsa: VUE_APP_API_MYELSA_URL,
};

export default appConfig;
